import { render, staticRenderFns } from "./SampleInformation.vue?vue&type=template&id=10907bde&scoped=true"
import script from "./SampleInformation.vue?vue&type=script&lang=js"
export * from "./SampleInformation.vue?vue&type=script&lang=js"
import style0 from "./SampleInformation.vue?vue&type=style&index=0&id=10907bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10907bde",
  null
  
)

export default component.exports